import React, { useState } from 'react';
import { Event } from '../types';
import EventCard from './EventCard';
import styles from './EventList.module.css';

interface EventListProps {
    events: Event[];
    isFavorite: (id: string) => boolean;
    hasUpvoted: (id: string) => boolean;
    onUpvote: (e: React.MouseEvent, eventId: string) => void;
    onToggleFavorite: (e: React.MouseEvent, eventId: string) => void;
    groupByStatus?: boolean;
    hideCompletedDefault?: boolean;
}

const EventList: React.FC<EventListProps> = ({
    events,
    isFavorite,
    hasUpvoted,
    onUpvote,
    onToggleFavorite,
    groupByStatus = true,
    hideCompletedDefault = true,
}) => {
    const [showCompleted, setShowCompleted] = useState(false);

    const live = events.filter((e) => e.status === 'live');
    const scheduled = events.filter((e) => e.status === 'scheduled');
    const completed = events.filter((e) => e.status === 'completed');
    const other = events.filter(
        (e) => e.status !== 'live' && e.status !== 'scheduled' && e.status !== 'completed'
    );

    const renderCards = (list: Event[]) =>
        list.map((event) => (
            <EventCard
                key={event.id}
                event={event}
                variant="row"
                isFavorite={isFavorite(event.id)}
                hasUpvoted={hasUpvoted(event.id)}
                onUpvote={onUpvote}
                onToggleFavorite={onToggleFavorite}
            />
        ));

    if (!groupByStatus) {
        return <div className={styles.list}>{renderCards(events)}</div>;
    }

    const completedHidden = hideCompletedDefault && completed.length > 0 && !showCompleted;

    return (
        <div className={styles.sections}>
            {live.length > 0 && (
                <section className={styles.section} aria-label="লাইভ ম্যাচ">
                    <h2 className={styles.sectionTitle}>
                        <span className={styles.liveDot} aria-hidden="true" />
                        লাইভ
                        <span className={styles.sectionCount}>{live.length}</span>
                    </h2>
                    <div className={styles.list}>{renderCards(live)}</div>
                </section>
            )}

            {scheduled.length > 0 && (
                <section className={styles.section} aria-label="আসন্ন ম্যাচ">
                    <h2 className={styles.sectionTitle}>
                        আসন্ন
                        <span className={styles.sectionCount}>{scheduled.length}</span>
                    </h2>
                    <div className={styles.list}>{renderCards(scheduled)}</div>
                </section>
            )}

            {other.length > 0 && (
                <section className={styles.section}>
                    <div className={styles.list}>{renderCards(other)}</div>
                </section>
            )}

            {completed.length > 0 && (
                <section className={styles.section} aria-label="সম্পন্ন ম্যাচ">
                    {completedHidden ? (
                        <button
                            type="button"
                            className={styles.expandBtn}
                            onClick={() => setShowCompleted(true)}
                        >
                            সম্পন্ন ম্যাচ দেখুন ({completed.length})
                        </button>
                    ) : (
                        <>
                            <h2 className={`${styles.sectionTitle} ${styles.muted}`}>
                                সম্পন্ন
                                <span className={styles.sectionCount}>{completed.length}</span>
                            </h2>
                            <div className={styles.list}>{renderCards(completed)}</div>
                        </>
                    )}
                </section>
            )}
        </div>
    );
};

export default EventList;
